// libraries
import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";

// components
import { NewNavbar } from "src/components";
import Hero from "../Hero/Hero";
import Contact from "../Contact/Contact";
import Reviews from "../Reviews/Reviews";
import Keywords from "../Keywords/Keywords";
import MoreEvents from "../MoreEvents/MoreEvents";
import Map from "../Map/Map";
import Tab from "../Tab/Tab";
import SeeMore from "../SeeMore/SeeMore";

import Section from "../../Section";

// api
import { getEventDetail } from "../api";

// context
// import UserContext from "src/context/User";
// contex
import { UserAuthContext } from "src/context/UserAuthContext";

// data
// import { event_detail } from "../data";

const Content = ({ eventId, timeId }) => {
  // const { user, userLocation } = useContext(UserContext);
  const { user, userLocation } = useContext(UserAuthContext);

  // state
  const [eventData, setEventData] = useState(null);

  useEffect(() => {
    if (eventId && timeId && userLocation) {
      let params = {
        eventId: +eventId,
        timeId: +timeId,
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
      };

      getEventDetail(params)
        .then((res) => {
          if (res.data.Status) {
            setEventData(res.data.Results);
          } else {
            toast.error(res.data.ErrorMessage);
          }
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  }, [eventId, timeId, userLocation]);

  return (
    <div>
      <NewNavbar isMobHide />
      <Section>
        <Hero data={eventData} />
        <Tab data={eventData} />
        <Map data={eventData} userLocation={user || userLocation} />
        {eventData?.PhoneNo !== "" && <Contact data={eventData} />}
        <Reviews data={eventData} setData={setEventData} />
        <Keywords data={eventData} />
        <MoreEvents data={eventData} />
        {/* <Action
          // ticket='20'
          title="This Event is starting soon"
          buttonTitle="Get Directions"
          buttonIcon={<img src={direction} alt="direction" />}
        /> */}
        {eventData && <SeeMore data={eventData} />}
      </Section>
    </div>
  );
};

export default Content;
